<!-- <img class="thumbnail-display-img"  -->
<img
  style="width: 60px; height: 60px"
  class="pointer border-radius"
  src="{{globals.GetXRSCustomContentURL() + 'Thumbnails/' + Content_GUID + '.jpg'}}"
  (error)="globals.onThumbnailError($event,'blank.jpg',null)"
  (click)="onThumbnailClick($event,'Content_GUID',Content_GUID, description)"
/>
